import { formatDateToMonthShort } from '@core/utils/filter'

export function isConsentExpired(gdprStatus, validUntil) {
  if (gdprStatus === 'expired') return true
  if (!validUntil) return false

  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const expiry = new Date(validUntil)
  expiry.setHours(0, 0, 0, 0)

  return expiry < today
}

export function formatConsentValidUntilLabel(validUntil, translate) {
  if (!validUntil) return null

  return translate('consentValidUntilDate', { date: formatDateToMonthShort(validUntil) })
}
